import { BaseQueryFn, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { API_FETCH_TIMEOUT } from 'shared/constants/api';
import { RootState } from 'shared/redux/store';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL as string,
  headers: {
    accept: `application/json`,
  },
  timeout: API_FETCH_TIMEOUT * 1000,
});

export const axiosBaseQuery =
  (
    {
      baseURL,
      token_required,
    }: Partial<{ baseURL: string; token_required: boolean }> = {
      baseURL: process.env.REACT_APP_API_URL as string,
      token_required: false,
    }
  ): BaseQueryFn<AxiosRequestConfig, unknown, unknown> =>
  async (requestOptions, { getState }) => {
    try {
      const config: AxiosRequestConfig = {
        baseURL,
        ...requestOptions,
      };

      if (token_required) {
        const token = (getState() as RootState).authSlice.token;

        config.headers = {
          ...requestOptions.headers,
          Authorization: `Bearer ${token}`,
        };
      }
      const result = await axiosInstance(config);

      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as AxiosError;
      return {
        error: { status: err.response?.status, data: err.response?.data },
      };
    }
  };

export const baseQueryWithAuth = (
  { baseUrl }: { baseUrl: string } = {
    baseUrl: process.env.REACT_APP_API_URL as string,
  }
) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).authSlice.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  });
